/**
 * Copyright 2020, IntraLinks, Inc. All rights reserved.
 */

var IlTippyTheme = {
  Dark: 'dark',
  Light: 'light'
};
var IlTippyPlacement = {
  Auto: 'auto',
  AutoStart: 'auto-start',
  AutoEnd: 'auto-end',
  Left: 'left',
  LeftStart: 'left-start',
  LeftEnd: 'left-end',
  Top: 'top',
  TopStart: 'top-start',
  TopEnd: 'top-end',
  Right: 'right',
  RightStart: 'right-start',
  RightEnd: 'right-end',
  Bottom: 'bottom',
  BottomStart: 'bottom-start',
  BottomEnd: 'bottom-end'
};

export { IlTippyPlacement, IlTippyTheme };
